import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

export interface ResponseDetails {
  opportunityCode: string;
  opportunityName: string;
}

interface OpportunityNameState {
  isLoading: boolean;
  data: ResponseDetails | null;
  error: string | null;
  isLoadingException: boolean;
  dataException: ResponseDetails | null;
  errorException: string | null;
}

const initialState: OpportunityNameState = {
  isLoading: false,
  data: null,
  error: null,
  isLoadingException: false,
  dataException: null,
  errorException: null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any

interface RequestDetailsOpportunityName {
  Action: string;
  opportunityCode: string;
}

export const fetchOpportunityName = createAsyncThunk<
  any,
  RequestDetailsOpportunityName
>(
  "OpportunityNameSlice/fetchOpportunityNameData",
  async (requestDetails, thunkApi) => {
    const requestParam = {
      Action: requestDetails.Action,
      OpportunityCode: requestDetails.opportunityCode,
    };

    try {
      const response = await httpClient.post("/order", requestParam);

      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get opportunity data",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: error?.response?.data?.Message
          ? error.response.data.Message
          : "Failed to get opportunity data",
      });
    }
  }
);

const OpportunityNameSlice = createSlice({
  name: "OpportunityNameSlice",
  initialState,
  reducers: {
    resetOpportunityNameState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpportunityName.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchOpportunityName.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchOpportunityName.rejected,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetOpportunityNameState } = OpportunityNameSlice.actions;

export default OpportunityNameSlice.reducer;
